export interface DropdownModel {
  value: string
  label: string
}

export const usersList: Array<DropdownModel> = []

export const languages: Array<DropdownModel> = [
  {value: 'id', label: 'Bahasa Indonesia - Indonesian'},
  {value: 'msa', label: 'Bahasa Melayu - Malay'},
  {value: 'ca', label: 'Català - Catalan'},
  {value: 'cs', label: 'Čeština - Czech'},
  {value: 'da', label: 'Dansk - Danish'},
  {value: 'de', label: 'Deutsch - German'},
  {value: 'en', label: 'English'},
  {value: 'en-gb', label: 'English UK - British English'},
  {value: 'es', label: 'Español - Spanish'},
  {value: 'fil', label: 'Filipino'},
  {value: 'fr', label: 'Français - French'},
  {value: 'ga', label: 'Gaeilge - Irish (beta)'},
  {value: 'gl', label: 'Galego - Galician (beta)'},
  {value: 'hr', label: 'Hrvatski - Croatian'},
  {value: 'it', label: 'Italiano - Italian'},
  {value: 'hu', label: 'Magyar - Hungarian'},
  {value: 'nl', label: 'Nederlands - Dutch'},
  {value: 'no', label: 'Norsk - Norwegian'},
  {value: 'pl', label: 'Polski - Polish'},
  {value: 'pt', label: 'Português - Portuguese'},
  {value: 'ro', label: 'Română - Romanian'},
  {value: 'sk', label: 'Slovenčina - Slovak'},
  {value: 'fi', label: 'Suomi - Finnish'},
  {value: 'sv', label: 'Svenska - Swedish'},
  {value: 'vi', label: 'Tiếng Việt - Vietnamese'},
  {value: 'tr', label: 'Türkçe - Turkish'},
  {value: 'el', label: 'Ελληνικά - Greek'},
  {value: 'bg', label: 'Български език - Bulgarian'},
  {value: 'ru', label: 'Русский - Russian'},
  {value: 'sr', label: 'Српски - Serbian'},
  {value: 'uk', label: 'Українська мова - Ukrainian'},
  {value: 'he', label: 'עִבְרִית - Hebrew'},
  {value: 'ur', label: 'اردو - Urdu (beta)'},
  {value: 'ar', label: 'العربية - Arabic'},
  {value: 'fa', label: 'فارسی - Persian'},
  {value: 'mr', label: 'मराठी - Marathi'},
  {value: 'hi', label: 'हिन्दी - Hindi'},
  {value: 'bn', label: 'বাংলা - Bangla'},
  {value: 'gu', label: 'ગુજરાતી - Gujarati'},
  {value: 'ta', label: 'தமிழ் - Tamil'},
  {value: 'kn', label: 'ಕನ್ನಡ - Kannada'},
  {value: 'th', label: 'ภาษาไทย - Thai'},
  {value: 'ko', label: '한국어 - Korean'},
  {value: 'ja', label: '日本語 - Japanese'},
  {value: 'zh-cn', label: '简体中文 - Simplified Chinese'},
  {value: 'zh-tw', label: '繁體中文 - Traditional Chinese'},
]

export const timeZone: Array<DropdownModel> = [
  {value: 'International Date Line West ', label: '(GMT-11:00) International Date Line West'},
  {value: 'Midway Island ', label: '(GMT-11:00) Midway Island'},
  {value: 'Samoa ', label: '(GMT-11:00) Samoa'},
  {value: 'Hawaii ', label: '(GMT-10:00) Hawaii'},
  {value: 'Alaska ', label: '(GMT-08:00) Alaska'},
  {value: 'Pacific Time (US &amp; Canada) ', label: '(GMT-07:00) Pacific Time (US &amp; Canada)'},
  {value: 'Tijuana ', label: '(GMT-07:00) Tijuana'},
  {value: 'Arizona ', label: '(GMT-07:00) Arizona'},
  {value: 'Mountain Time (US &amp; Canada) ', label: '(GMT-06:00) Mountain Time (US &amp; Canada)'},
  {value: 'Chihuahua ', label: '(GMT-06:00) Chihuahua'},
  {value: 'Mazatlan ', label: '(GMT-06:00) Mazatlan'},
  {value: 'Saskatchewan ', label: '(GMT-06:00) Saskatchewan'},
  {value: 'Central America ', label: '(GMT-06:00) Central America'},
  {value: 'Central Time (US &amp; Canada) ', label: '(GMT-05:00) Central Time (US &amp; Canada)'},
  {value: 'Guadalajara ', label: '(GMT-05:00) Guadalajara'},
  {value: 'Mexico City ', label: '(GMT-05:00) Mexico City'},
  {value: 'Monterrey ', label: '(GMT-05:00) Monterrey'},
  {value: 'Bogota ', label: '(GMT-05:00) Bogota'},
  {value: 'Lima ', label: '(GMT-05:00) Lima'},
  {value: 'Quito ', label: '(GMT-05:00) Quito'},
  {value: 'Eastern Time (US &amp; Canada) ', label: '(GMT-04:00) Eastern Time (US &amp; Canada)'},
  {value: 'Indiana (East) ', label: '(GMT-04:00) Indiana (East)'},
  {value: 'Caracas ', label: '(GMT-04:00) Caracas'},
  {value: 'La Paz ', label: '(GMT-04:00) La Paz'},
  {value: 'Georgetown ', label: '(GMT-04:00) Georgetown'},
  {value: 'Atlantic Time (Canada) ', label: '(GMT-03:00) Atlantic Time (Canada)'},
  {value: 'Santiago ', label: '(GMT-03:00) Santiago'},
  {value: 'Brasilia ', label: '(GMT-03:00) Brasilia'},
  {value: 'Buenos Aires ', label: '(GMT-03:00) Buenos Aires'},
  {value: 'Newfoundland ', label: '(GMT-02:30) Newfoundland'},
  {value: 'Greenland ', label: '(GMT-02:00) Greenland'},
  {value: 'Mid-Atlantic ', label: '(GMT-02:00) Mid-Atlantic'},
  {value: 'Cape Verde Is. ', label: '(GMT-01:00) Cape Verde Is.'},
  {value: 'Azores ', label: '(GMT) Azores'},
  {value: 'Monrovia ', label: '(GMT) Monrovia'},
  {value: 'UTC ', label: '(GMT) UTC'},
  {value: 'Dublin ', label: '(GMT+01:00) Dublin'},
  {value: 'Edinburgh ', label: '(GMT+01:00) Edinburgh'},
  {value: 'Lisbon ', label: '(GMT+01:00) Lisbon'},
  {value: 'London ', label: '(GMT+01:00) London'},
  {value: 'Casablanca ', label: '(GMT+01:00) Casablanca'},
  {value: 'West Central Africa ', label: '(GMT+01:00) West Central Africa'},
  {value: 'Belgrade ', label: '(GMT+02:00) Belgrade'},
  {value: 'Bratislava ', label: '(GMT+02:00) Bratislava'},
  {value: 'Budapest ', label: '(GMT+02:00) Budapest'},
  {value: 'Ljubljana ', label: '(GMT+02:00) Ljubljana'},
  {value: 'Prague ', label: '(GMT+02:00) Prague'},
  {value: 'Sarajevo ', label: '(GMT+02:00) Sarajevo'},
  {value: 'Skopje ', label: '(GMT+02:00) Skopje'},
  {value: 'Warsaw ', label: '(GMT+02:00) Warsaw'},
  {value: 'Zagreb ', label: '(GMT+02:00) Zagreb'},
  {value: 'Brussels ', label: '(GMT+02:00) Brussels'},
  {value: 'Copenhagen ', label: '(GMT+02:00) Copenhagen'},
  {value: 'Madrid ', label: '(GMT+02:00) Madrid'},
  {value: 'Paris ', label: '(GMT+02:00) Paris'},
  {value: 'Amsterdam ', label: '(GMT+02:00) Amsterdam'},
  {value: 'Berlin ', label: '(GMT+02:00) Berlin'},
  {value: 'Bern ', label: '(GMT+02:00) Bern'},
  {value: 'Rome ', label: '(GMT+02:00) Rome'},
  {value: 'Stockholm ', label: '(GMT+02:00) Stockholm'},
  {value: 'Vienna ', label: '(GMT+02:00) Vienna'},
  {value: 'Cairo ', label: '(GMT+02:00) Cairo'},
  {value: 'Harare ', label: '(GMT+02:00) Harare'},
  {value: 'Pretoria ', label: '(GMT+02:00) Pretoria'},
  {value: 'Bucharest ', label: '(GMT+03:00) Bucharest'},
  {value: 'Helsinki ', label: '(GMT+03:00) Helsinki'},
  {value: 'Kiev ', label: '(GMT+03:00) Kiev'},
  {value: 'Kyiv ', label: '(GMT+03:00) Kyiv'},
  {value: 'Riga ', label: '(GMT+03:00) Riga'},
  {value: 'Sofia ', label: '(GMT+03:00) Sofia'},
  {value: 'Tallinn ', label: '(GMT+03:00) Tallinn'},
  {value: 'Vilnius ', label: '(GMT+03:00) Vilnius'},
  {value: 'Athens ', label: '(GMT+03:00) Athens'},
  {value: 'Istanbul ', label: '(GMT+03:00) Istanbul'},
  {value: 'Minsk ', label: '(GMT+03:00) Minsk'},
  {value: 'Jerusalem ', label: '(GMT+03:00) Jerusalem'},
  {value: 'Moscow ', label: '(GMT+03:00) Moscow'},
  {value: 'St. Petersburg ', label: '(GMT+03:00) St. Petersburg'},
  {value: 'Volgograd ', label: '(GMT+03:00) Volgograd'},
  {value: 'Kuwait ', label: '(GMT+03:00) Kuwait'},
  {value: 'Riyadh ', label: '(GMT+03:00) Riyadh'},
  {value: 'Nairobi ', label: '(GMT+03:00) Nairobi'},
  {value: 'Baghdad ', label: '(GMT+03:00) Baghdad'},
  {value: 'Abu Dhabi ', label: '(GMT+04:00) Abu Dhabi'},
  {value: 'Muscat ', label: '(GMT+04:00) Muscat'},
  {value: 'Baku ', label: '(GMT+04:00) Baku'},
  {value: 'Tbilisi ', label: '(GMT+04:00) Tbilisi'},
  {value: 'Yerevan ', label: '(GMT+04:00) Yerevan'},
  {value: 'Tehran ', label: '(GMT+04:30) Tehran'},
  {value: 'Kabul ', label: '(GMT+04:30) Kabul'},
  {value: 'Ekaterinburg ', label: '(GMT+05:00) Ekaterinburg'},
  {value: 'Islamabad ', label: '(GMT+05:00) Islamabad'},
  {value: 'Karachi ', label: '(GMT+05:00) Karachi'},
  {value: 'Tashkent ', label: '(GMT+05:00) Tashkent'},
  {value: 'Chennai ', label: '(GMT+05:30) Chennai'},
  {value: 'Kolkata ', label: '(GMT+05:30) Kolkata'},
  {value: 'Mumbai ', label: '(GMT+05:30) Mumbai'},
  {value: 'New Delhi ', label: '(GMT+05:30) New Delhi'},
  {value: 'Sri Jayawardenepura ', label: '(GMT+05:30) Sri Jayawardenepura'},
  {value: 'Kathmandu ', label: '(GMT+05:45) Kathmandu'},
  {value: 'Astana ', label: '(GMT+06:00) Astana'},
  {value: 'Dhaka ', label: '(GMT+06:00) Dhaka'},
  {value: 'Almaty ', label: '(GMT+06:00) Almaty'},
  {value: 'Urumqi ', label: '(GMT+06:00) Urumqi'},
  {value: 'Rangoon ', label: '(GMT+06:30) Rangoon'},
  {value: 'Novosibirsk ', label: '(GMT+07:00) Novosibirsk'},
  {value: 'Bangkok ', label: '(GMT+07:00) Bangkok'},
  {value: 'Hanoi ', label: '(GMT+07:00) Hanoi'},
  {value: 'Jakarta ', label: '(GMT+07:00) Jakarta'},
  {value: 'Krasnoyarsk ', label: '(GMT+07:00) Krasnoyarsk'},
  {value: 'Beijing ', label: '(GMT+08:00) Beijing'},
  {value: 'Chongqing ', label: '(GMT+08:00) Chongqing'},
  {value: 'Hong Kong ', label: '(GMT+08:00) Hong Kong'},
  {value: 'Kuala Lumpur ', label: '(GMT+08:00) Kuala Lumpur'},
  {value: 'Singapore ', label: '(GMT+08:00) Singapore'},
  {value: 'Taipei ', label: '(GMT+08:00) Taipei'},
  {value: 'Perth ', label: '(GMT+08:00) Perth'},
  {value: 'Irkutsk ', label: '(GMT+08:00) Irkutsk'},
  {value: 'Ulaan Bataar ', label: '(GMT+08:00) Ulaan Bataar'},
  {value: 'Seoul ', label: '(GMT+09:00) Seoul'},
  {value: 'Osaka ', label: '(GMT+09:00) Osaka'},
  {value: 'Sapporo ', label: '(GMT+09:00) Sapporo'},
  {value: 'Tokyo ', label: '(GMT+09:00) Tokyo'},
  {value: 'Yakutsk ', label: '(GMT+09:00) Yakutsk'},
  {value: 'Darwin ', label: '(GMT+09:30) Darwin'},
  {value: 'Adelaide ', label: '(GMT+09:30) Adelaide'},
  {value: 'Canberra ', label: '(GMT+10:00) Canberra'},
  {value: 'Melbourne ', label: '(GMT+10:00) Melbourne'},
  {value: 'Sydney ', label: '(GMT+10:00) Sydney'},
  {value: 'Brisbane ', label: '(GMT+10:00) Brisbane'},
  {value: 'Hobart ', label: '(GMT+10:00) Hobart'},
  {value: 'Vladivostok ', label: '(GMT+10:00) Vladivostok'},
  {value: 'Guam ', label: '(GMT+10:00) Guam'},
  {value: 'Port Moresby ', label: '(GMT+10:00) Port Moresby'},
  {value: 'Solomon Is. ', label: '(GMT+10:00) Solomon Is.'},
  {value: 'Magadan ', label: '(GMT+11:00) Magadan'},
  {value: 'New Caledonia ', label: '(GMT+11:00) New Caledonia'},
  {value: 'Fiji ', label: '(GMT+12:00) Fiji'},
  {value: 'Kamchatka ', label: '(GMT+12:00) Kamchatka'},
  {value: 'Marshall Is. ', label: '(GMT+12:00) Marshall Is.'},
  {value: 'Auckland ', label: '(GMT+12:00) Auckland'},
  {value: 'Wellington ', label: '(GMT+12:00) Wellington'},
  {value: "Nuku'alofa", label: "(GMT+13:00) Nuku'alofa"},
]

export const currency: Array<DropdownModel> = [
  {label: 'Afghan Afghani', value: 'AFA'},
  {label: 'Albanian Lek', value: 'ALL'},
  {label: 'Algerian Dinar', value: 'DZD'},
  {label: 'Angolan Kwanza', value: 'AOA'},
  {label: 'Argentine Peso', value: 'ARS'},
  {label: 'Armenian Dram', value: 'AMD'},
  {label: 'Aruban Florin', value: 'AWG'},
  {label: 'Australian Dollar', value: 'AUD'},
  {label: 'Azerbaijani Manat', value: 'AZN'},
  {label: 'Bahamian Dollar', value: 'BSD'},
  {label: 'Bahraini Dinar', value: 'BHD'},
  {label: 'Bangladeshi Taka', value: 'BDT'},
  {label: 'Barbadian Dollar', value: 'BBD'},
  {label: 'Belarusian Ruble', value: 'BYR'},
  {label: 'Belgian Franc', value: 'BEF'},
  {label: 'Belize Dollar', value: 'BZD'},
  {label: 'Bermudan Dollar', value: 'BMD'},
  {label: 'Bhutanese Ngultrum', value: 'BTN'},
  {label: 'Bitcoin', value: 'BTC'},
  {label: 'Bolivian Boliviano', value: 'BOB'},
  {label: 'Bosnia-Herzegovina Convertible Mark', value: 'BAM'},
  {label: 'Botswanan Pula', value: 'BWP'},
  {label: 'Brazilian Real', value: 'BRL'},
  {label: 'British Pound Sterling', value: 'GBP'},
  {label: 'Brunei Dollar', value: 'BND'},
  {label: 'Bulgarian Lev', value: 'BGN'},
  {label: 'Burundian Franc', value: 'BIF'},
  {label: 'Cambodian Riel', value: 'KHR'},
  {label: 'Canadian Dollar', value: 'CAD'},
  {label: 'Cape Verdean Escudo', value: 'CVE'},
  {label: 'Cayman Islands Dollar', value: 'KYD'},
  {label: 'CFA Franc BCEAO', value: 'XOF'},
  {label: 'CFA Franc BEAC', value: 'XAF'},
  {label: 'CFP Franc', value: 'XPF'},
  {label: 'Chilean Peso', value: 'CLP'},
  {label: 'Chinese Yuan', value: 'CNY'},
  {label: 'Colombian Peso', value: 'COP'},
  {label: 'Comorian Franc', value: 'KMF'},
  {label: 'Congolese Franc', value: 'CDF'},
  {label: 'Costa Rican ColÃ³n', value: 'CRC'},
  {label: 'Croatian Kuna', value: 'HRK'},
  {label: 'Cuban Convertible Peso', value: 'CUC'},
  {label: 'Czech Republic Koruna', value: 'CZK'},
  {label: 'Danish Krone', value: 'DKK'},
  {label: 'Djiboutian Franc', value: 'DJF'},
  {label: 'Dominican Peso', value: 'DOP'},
  {label: 'East Caribbean Dollar', value: 'XCD'},
  {label: 'Egyptian Pound', value: 'EGP'},
  {label: 'Eritrean Nakfa', value: 'ERN'},
  {label: 'Estonian Kroon', value: 'EEK'},
  {label: 'Ethiopian Birr', value: 'ETB'},
  {label: 'Euro', value: 'EUR'},
  {label: 'Falkland Islands Pound', value: 'FKP'},
  {label: 'Fijian Dollar', value: 'FJD'},
  {label: 'Gambian Dalasi', value: 'GMD'},
  {label: 'Georgian Lari', value: 'GEL'},
  {label: 'German Mark', value: 'DEM'},
  {label: 'Ghanaian Cedi', value: 'GHS'},
  {label: 'Gibraltar Pound', value: 'GIP'},
  {label: 'Greek Drachma', value: 'GRD'},
  {label: 'Guatemalan Quetzal', value: 'GTQ'},
  {label: 'Guinean Franc', value: 'GNF'},
  {label: 'Guyanaese Dollar', value: 'GYD'},
  {label: 'Haitian Gourde', value: 'HTG'},
  {label: 'Honduran Lempira', value: 'HNL'},
  {label: 'Hong Kong Dollar', value: 'HKD'},
  {label: 'Hungarian Forint', value: 'HUF'},
  {label: 'Icelandic KrÃ³na', value: 'ISK'},
  {label: 'Indian Rupee', value: 'INR'},
  {label: 'Indonesian Rupiah', value: 'IDR'},
  {label: 'Iranian Rial', value: 'IRR'},
  {label: 'Iraqi Dinar', value: 'IQD'},
  {label: 'Israeli New Sheqel', value: 'ILS'},
  {label: 'Italian Lira', value: 'ITL'},
  {label: 'Jamaican Dollar', value: 'JMD'},
  {label: 'Japanese Yen', value: 'JPY'},
  {label: 'Jordanian Dinar', value: 'JOD'},
  {label: 'Kazakhstani Tenge', value: 'KZT'},
  {label: 'Kenyan Shilling', value: 'KES'},
  {label: 'Kuwaiti Dinar', value: 'KWD'},
  {label: 'Kyrgystani Som', value: 'KGS'},
  {label: 'Laotian Kip', value: 'LAK'},
  {label: 'Latvian Lats', value: 'LVL'},
  {label: 'Lebanese Pound', value: 'LBP'},
  {label: 'Lesotho Loti', value: 'LSL'},
  {label: 'Liberian Dollar', value: 'LRD'},
  {label: 'Libyan Dinar', value: 'LYD'},
  {label: 'Lithuanian Litas', value: 'LTL'},
  {label: 'Macanese Pataca', value: 'MOP'},
  {label: 'Macedonian Denar', value: 'MKD'},
  {label: 'Malagasy Ariary', value: 'MGA'},
  {label: 'Malawian Kwacha', value: 'MWK'},
  {label: 'Malaysian Ringgit', value: 'MYR'},
  {label: 'Maldivian Rufiyaa', value: 'MVR'},
  {label: 'Mauritanian Ouguiya', value: 'MRO'},
  {label: 'Mauritian Rupee', value: 'MUR'},
  {label: 'Mexican Peso', value: 'MXN'},
  {label: 'Moldovan Leu', value: 'MDL'},
  {label: 'Mongolian Tugrik', value: 'MNT'},
  {label: 'Moroccan Dirham', value: 'MAD'},
  {label: 'Mozambican Metical', value: 'MZM'},
  {label: 'Myanmar Kyat', value: 'MMK'},
  {label: 'Namibian Dollar', value: 'NAD'},
  {label: 'Nepalese Rupee', value: 'NPR'},
  {label: 'Netherlands Antillean Guilder', value: 'ANG'},
  {label: 'New Taiwan Dollar', value: 'TWD'},
  {label: 'New Zealand Dollar', value: 'NZD'},
  {label: 'Nicaraguan CÃ³rdoba', value: 'NIO'},
  {label: 'Nigerian Naira', value: 'NGN'},
  {label: 'North Korean Won', value: 'KPW'},
  {label: 'Norwegian Krone', value: 'NOK'},
  {label: 'Omani Rial', value: 'OMR'},
  {label: 'Pakistani Rupee', value: 'PKR'},
  {label: 'Panamanian Balboa', value: 'PAB'},
  {label: 'Papua New Guinean Kina', value: 'PGK'},
  {label: 'Paraguayan Guarani', value: 'PYG'},
  {label: 'Peruvian Nuevo Sol', value: 'PEN'},
  {label: 'Philippine Peso', value: 'PHP'},
  {label: 'Polish Zloty', value: 'PLN'},
  {label: 'Qatari Rial', value: 'QAR'},
  {label: 'Romanian Leu', value: 'RON'},
  {label: 'Russian Ruble', value: 'RUB'},
  {label: 'Rwandan Franc', value: 'RWF'},
  {label: 'Salvadoran ColÃ³n', value: 'SVC'},
  {label: 'Samoan Tala', value: 'WST'},
  {label: 'Saudi Riyal', value: 'SAR'},
  {label: 'Serbian Dinar', value: 'RSD'},
  {label: 'Seychellois Rupee', value: 'SCR'},
  {label: 'Sierra Leonean Leone', value: 'SLL'},
  {label: 'Singapore Dollar', value: 'SGD'},
  {label: 'Slovak Koruna', value: 'SKK'},
  {label: 'Solomon Islands Dollar', value: 'SBD'},
  {label: 'Somali Shilling', value: 'SOS'},
  {label: 'South African Rand', value: 'ZAR'},
  {label: 'South Korean Won', value: 'KRW'},
  {label: 'Special Drawing Rights', value: 'XDR'},
  {label: 'Sri Lankan Rupee', value: 'LKR'},
  {label: 'St. Helena Pound', value: 'SHP'},
  {label: 'Sudanese Pound', value: 'SDG'},
  {label: 'Surinamese Dollar', value: 'SRD'},
  {label: 'Swazi Lilangeni', value: 'SZL'},
  {label: 'Swedish Krona', value: 'SEK'},
  {label: 'Swiss Franc', value: 'CHF'},
  {label: 'Syrian Pound', value: 'SYP'},
  {label: 'São Tomé and Príncipe Dobra', value: 'STD'},
  {label: 'Tajikistani Somoni', value: 'TJS'},
  {label: 'Tanzanian Shilling', value: 'TZS'},
  {label: 'Thai Baht', value: 'THB'},
  {label: "Tongan Pa'anga", value: 'TOP'},
  {label: 'Trinidad & Tobago Dollar', value: 'TTD'},
  {label: 'Tunisian Dinar', value: 'TND'},
  {label: 'Turkish Lira', value: 'TRY'},
  {label: 'Turkmenistani Manat', value: 'TMT'},
  {label: 'Ugandan Shilling', value: 'UGX'},
  {label: 'Ukrainian Hryvnia', value: 'UAH'},
  {label: 'United Arab Emirates Dirham', value: 'AED'},
  {label: 'Uruguayan Peso', value: 'UYU'},
  {label: 'US Dollar', value: 'USD'},
  {label: 'Uzbekistan Som', value: 'UZS'},
  {label: 'Vanuatu Vatu', value: 'VUV'},
  {label: 'Venezuelan BolÃvar', value: 'VEF'},
  {label: 'Vietnamese Dong', value: 'VND'},
  {label: 'Yemeni Rial', value: 'YER'},
  {label: 'Zambian Kwacha', value: 'ZMK'},
]

export const checkPermission: Array<DropdownModel> = [
  {value: 'TOKEN', label: 'Token'},
  {value: 'EVERYTIME', label: 'Every Time'},
]

export const modulePermission: Array<DropdownModel> = [
  {value: 'CLOSED', label: 'Closed'},
  {value: 'LIMITED', label: 'Limited'},
  {value: 'OPENED', label: 'Opened'},
]

export const country: Array<DropdownModel> = [
  {label: 'Afghanistan', value: 'AF'},
  {label: 'Aland Islands', value: 'AX'},
  {label: 'Albania', value: 'AL'},
  {label: 'Algeria', value: 'DZ'},
  {label: 'American Samoa', value: 'AS'},
  {label: 'Andorra', value: 'AD'},
  {label: 'Angola', value: 'AO'},
  {label: 'Anguilla', value: 'AI'},
  {label: 'Antarctica', value: 'AQ'},
  {label: 'Antigua and Barbuda', value: 'AG'},
  {label: 'Argentina', value: 'AR'},
  {label: 'Armenia', value: 'AM'},
  {label: 'Aruba', value: 'AW'},
  {label: 'Australia', value: 'AU'},
  {label: 'Austria', value: 'AT'},
  {label: 'Azerbaijan', value: 'AZ'},
  {label: 'Bahamas', value: 'BS'},
  {label: 'Bahrain', value: 'BH'},
  {label: 'Bangladesh', value: 'BD'},
  {label: 'Barbados', value: 'BB'},
  {label: 'Belarus', value: 'BY'},
  {label: 'Belgium', value: 'BE'},
  {label: 'Belize', value: 'BZ'},
  {label: 'Benin', value: 'BJ'},
  {label: 'Bermuda', value: 'BM'},
  {label: 'Bhutan', value: 'BT'},
  {label: 'Bolivia', value: 'BO'},
  {label: 'Bonaire, Sint Eustatius and Saba', value: 'BQ'},
  {label: 'Bosnia and Herzegovina', value: 'BA'},
  {label: 'Botswana', value: 'BW'},
  {label: 'Bouvet Island', value: 'BV'},
  {label: 'Brazil', value: 'BR'},
  {label: 'British Indian Ocean Territory', value: 'IO'},
  {label: 'Brunei Darussalam', value: 'BN'},
  {label: 'Bulgaria', value: 'BG'},
  {label: 'Burkina Faso', value: 'BF'},
  {label: 'Burundi', value: 'BI'},
  {label: 'Cambodia', value: 'KH'},
  {label: 'Cameroon', value: 'CM'},
  {label: 'Canada', value: 'CA'},
  {label: 'Cape Verde', value: 'CV'},
  {label: 'Cayman Islands', value: 'KY'},
  {label: 'Central African Republic', value: 'CF'},
  {label: 'Chad', value: 'TD'},
  {label: 'Chile', value: 'CL'},
  {label: 'China', value: 'CN'},
  {label: 'Christmas Island', value: 'CX'},
  {label: 'Cocos (Keeling) Islands', value: 'CC'},
  {label: 'Colombia', value: 'CO'},
  {label: 'Comoros', value: 'KM'},
  {label: 'Congo', value: 'CG'},
  {label: 'Congo, Democratic Republic of the Congo', value: 'CD'},
  {label: 'Cook Islands', value: 'CK'},
  {label: 'Costa Rica', value: 'CR'},
  {label: "Cote D'Ivoire", value: 'CI'},
  {label: 'Croatia', value: 'HR'},
  {label: 'Cuba', value: 'CU'},
  {label: 'Curacao', value: 'CW'},
  {label: 'Cyprus', value: 'CY'},
  {label: 'Czech Republic', value: 'CZ'},
  {label: 'Denmark', value: 'DK'},
  {label: 'Djibouti', value: 'DJ'},
  {label: 'Dominica', value: 'DM'},
  {label: 'Dominican Republic', value: 'DO'},
  {label: 'Ecuador', value: 'EC'},
  {label: 'Egypt', value: 'EG'},
  {label: 'El Salvador', value: 'SV'},
  {label: 'Equatorial Guinea', value: 'GQ'},
  {label: 'Eritrea', value: 'ER'},
  {label: 'Estonia', value: 'EE'},
  {label: 'Ethiopia', value: 'ET'},
  {label: 'Falkland Islands (Malvinas)', value: 'FK'},
  {label: 'Faroe Islands', value: 'FO'},
  {label: 'Fiji', value: 'FJ'},
  {label: 'Finland', value: 'FI'},
  {label: 'France', value: 'FR'},
  {label: 'French Guiana', value: 'GF'},
  {label: 'French Polynesia', value: 'PF'},
  {label: 'French Southern Territories', value: 'TF'},
  {label: 'Gabon', value: 'GA'},
  {label: 'Gambia', value: 'GM'},
  {label: 'Georgia', value: 'GE'},
  {label: 'Germany', value: 'DE'},
  {label: 'Ghana', value: 'GH'},
  {label: 'Gibraltar', value: 'GI'},
  {label: 'Greece', value: 'GR'},
  {label: 'Greenland', value: 'GL'},
  {label: 'Grenada', value: 'GD'},
  {label: 'Guadeloupe', value: 'GP'},
  {label: 'Guam', value: 'GU'},
  {label: 'Guatemala', value: 'GT'},
  {label: 'Guernsey', value: 'GG'},
  {label: 'Guinea', value: 'GN'},
  {label: 'Guinea-Bissau', value: 'GW'},
  {label: 'Guyana', value: 'GY'},
  {label: 'Haiti', value: 'HT'},
  {label: 'Heard Island and Mcdonald Islands', value: 'HM'},
  {label: 'Holy See (Vatican City State)', value: 'VA'},
  {label: 'Honduras', value: 'HN'},
  {label: 'Hong Kong', value: 'HK'},
  {label: 'Hungary', value: 'HU'},
  {label: 'Iceland', value: 'IS'},
  {label: 'India', value: 'IN'},
  {label: 'Indonesia', value: 'ID'},
  {label: 'Iran, Islamic Republic of', value: 'IR'},
  {label: 'Iraq', value: 'IQ'},
  {label: 'Ireland', value: 'IE'},
  {label: 'Isle of Man', value: 'IM'},
  {label: 'Israel', value: 'IL'},
  {label: 'Italy', value: 'IT'},
  {label: 'Jamaica', value: 'JM'},
  {label: 'Japan', value: 'JP'},
  {label: 'Jersey', value: 'JE'},
  {label: 'Jordan', value: 'JO'},
  {label: 'Kazakhstan', value: 'KZ'},
  {label: 'Kenya', value: 'KE'},
  {label: 'Kiribati', value: 'KI'},
  {label: "Korea, Democratic People's Republic of", value: 'KP'},
  {label: 'Korea, Republic of', value: 'KR'},
  {label: 'Kosovo', value: 'XK'},
  {label: 'Kuwait', value: 'KW'},
  {label: 'Kyrgyzstan', value: 'KG'},
  {label: "Lao People's Democratic Republic", value: 'LA'},
  {label: 'Latvia', value: 'LV'},
  {label: 'Lebanon', value: 'LB'},
  {label: 'Lesotho', value: 'LS'},
  {label: 'Liberia', value: 'LR'},
  {label: 'Libyan Arab Jamahiriya', value: 'LY'},
  {label: 'Liechtenstein', value: 'LI'},
  {label: 'Lithuania', value: 'LT'},
  {label: 'Luxembourg', value: 'LU'},
  {label: 'Macao', value: 'MO'},
  {label: 'Macedonia, the Former Yugoslav Republic of', value: 'MK'},
  {label: 'Madagascar', value: 'MG'},
  {label: 'Malawi', value: 'MW'},
  {label: 'Malaysia', value: 'MY'},
  {label: 'Maldives', value: 'MV'},
  {label: 'Mali', value: 'ML'},
  {label: 'Malta', value: 'MT'},
  {label: 'Marshall Islands', value: 'MH'},
  {label: 'Martinique', value: 'MQ'},
  {label: 'Mauritania', value: 'MR'},
  {label: 'Mauritius', value: 'MU'},
  {label: 'Mayotte', value: 'YT'},
  {label: 'Mexico', value: 'MX'},
  {label: 'Micronesia, Federated States of', value: 'FM'},
  {label: 'Moldova, Republic of', value: 'MD'},
  {label: 'Monaco', value: 'MC'},
  {label: 'Mongolia', value: 'MN'},
  {label: 'Montenegro', value: 'ME'},
  {label: 'Montserrat', value: 'MS'},
  {label: 'Morocco', value: 'MA'},
  {label: 'Mozambique', value: 'MZ'},
  {label: 'Myanmar', value: 'MM'},
  {label: 'Namibia', value: 'NA'},
  {label: 'Nauru', value: 'NR'},
  {label: 'Nepal', value: 'NP'},
  {label: 'Netherlands', value: 'NL'},
  {label: 'Netherlands Antilles', value: 'AN'},
  {label: 'New Caledonia', value: 'NC'},
  {label: 'New Zealand', value: 'NZ'},
  {label: 'Nicaragua', value: 'NI'},
  {label: 'Niger', value: 'NE'},
  {label: 'Nigeria', value: 'NG'},
  {label: 'Niue', value: 'NU'},
  {label: 'Norfolk Island', value: 'NF'},
  {label: 'Northern Mariana Islands', value: 'MP'},
  {label: 'Norway', value: 'NO'},
  {label: 'Oman', value: 'OM'},
  {label: 'Pakistan', value: 'PK'},
  {label: 'Palau', value: 'PW'},
  {label: 'Palestinian Territory, Occupied', value: 'PS'},
  {label: 'Panama', value: 'PA'},
  {label: 'Papua New Guinea', value: 'PG'},
  {label: 'Paraguay', value: 'PY'},
  {label: 'Peru', value: 'PE'},
  {label: 'Philippines', value: 'PH'},
  {label: 'Pitcairn', value: 'PN'},
  {label: 'Poland', value: 'PL'},
  {label: 'Portugal', value: 'PT'},
  {label: 'Puerto Rico', value: 'PR'},
  {label: 'Qatar', value: 'QA'},
  {label: 'Reunion', value: 'RE'},
  {label: 'Romania', value: 'RO'},
  {label: 'Russian Federation', value: 'RU'},
  {label: 'Rwanda', value: 'RW'},
  {label: 'Saint Barthelemy', value: 'BL'},
  {label: 'Saint Helena', value: 'SH'},
  {label: 'Saint Kitts and Nevis', value: 'KN'},
  {label: 'Saint Lucia', value: 'LC'},
  {label: 'Saint Martin', value: 'MF'},
  {label: 'Saint Pierre and Miquelon', value: 'PM'},
  {label: 'Saint Vincent and the Grenadines', value: 'VC'},
  {label: 'Samoa', value: 'WS'},
  {label: 'San Marino', value: 'SM'},
  {label: 'Sao Tome and Principe', value: 'ST'},
  {label: 'Saudi Arabia', value: 'SA'},
  {label: 'Senegal', value: 'SN'},
  {label: 'Serbia', value: 'RS'},
  {label: 'Serbia and Montenegro', value: 'CS'},
  {label: 'Seychelles', value: 'SC'},
  {label: 'Sierra Leone', value: 'SL'},
  {label: 'Singapore', value: 'SG'},
  {label: 'Sint Maarten', value: 'SX'},
  {label: 'Slovakia', value: 'SK'},
  {label: 'Slovenia', value: 'SI'},
  {label: 'Solomon Islands', value: 'SB'},
  {label: 'Somalia', value: 'SO'},
  {label: 'South Africa', value: 'ZA'},
  {label: 'South Georgia and the South Sandwich Islands', value: 'GS'},
  {label: 'South Sudan', value: 'SS'},
  {label: 'Spain', value: 'ES'},
  {label: 'Sri Lanka', value: 'LK'},
  {label: 'Sudan', value: 'SD'},
  {label: 'Suriname', value: 'SR'},
  {label: 'Svalbard and Jan Mayen', value: 'SJ'},
  {label: 'Swaziland', value: 'SZ'},
  {label: 'Sweden', value: 'SE'},
  {label: 'Switzerland', value: 'CH'},
  {label: 'Syrian Arab Republic', value: 'SY'},
  {label: 'Taiwan, Province of China', value: 'TW'},
  {label: 'Tajikistan', value: 'TJ'},
  {label: 'Tanzania, United Republic of', value: 'TZ'},
  {label: 'Thailand', value: 'TH'},
  {label: 'Timor-Leste', value: 'TL'},
  {label: 'Togo', value: 'TG'},
  {label: 'Tokelau', value: 'TK'},
  {label: 'Tonga', value: 'TO'},
  {label: 'Trinidad and Tobago', value: 'TT'},
  {label: 'Tunisia', value: 'TN'},
  {label: 'Turkey', value: 'TR'},
  {label: 'Turkmenistan', value: 'TM'},
  {label: 'Turks and Caicos Islands', value: 'TC'},
  {label: 'Tuvalu', value: 'TV'},
  {label: 'Uganda', value: 'UG'},
  {label: 'Ukraine', value: 'UA'},
  {label: 'United Arab Emirates', value: 'AE'},
  {label: 'United Kingdom', value: 'GB'},
  {label: 'United States', value: 'US'},
  {label: 'United States Minor Outlying Islands', value: 'UM'},
  {label: 'Uruguay', value: 'UY'},
  {label: 'Uzbekistan', value: 'UZ'},
  {label: 'Vanuatu', value: 'VU'},
  {label: 'Venezuela', value: 'VE'},
  {label: 'Viet Nam', value: 'VN'},
  {label: 'Virgin Islands, British', value: 'VG'},
  {label: 'Virgin Islands, U.s.', value: 'VI'},
  {label: 'Wallis and Futuna', value: 'WF'},
  {label: 'Western Sahara', value: 'EH'},
  {label: 'Yemen', value: 'YE'},
  {label: 'Zambia', value: 'ZM'},
  {label: 'Zimbabwe', value: 'ZW'},
]

export const days: Array<DropdownModel> = [
  {label: 'Sunday', value: 'Sunday'},
  {label: 'Monday', value: 'Monday'},
  {label: 'Tuesday', value: 'Tuesday'},
  {label: 'Wednesday', value: 'Wednesday'},
  {label: 'Thursday', value: 'Thursday'},
  {label: 'Friday', value: 'Friday'},
  {label: 'Saturday', value: 'Saturday'},
]